import { visit } from '../libs/Visitor'
import { IAM } from '../types/iam'
import { MessageResponse, DataResponse } from '../types/response'

export type QueryUserResponse = DataResponse<IAM.User[]>
export type FetchAllUserResponse = DataResponse<IAM.User[]>
export type FetchUserResponse = DataResponse<IAM.User[]>

export const user = {
  create(user: IAM.User) {
    return visit<QueryUserResponse>({
      method: 'POST',
      data: user
    })
  },

  query(q: string) {
    return visit<QueryUserResponse>({
      method: 'GET',
      url: 'users/query?q=' + q
    })
  },

  fetchAll() {
    return visit<FetchAllUserResponse>({
      method: 'GET',
      url: 'users'
    })
  },

  fetch(userIds: Array<number | string>) {
    return visit<FetchUserResponse>({
      method: 'GET',
      url: 'users/' + userIds.toString(),
      headers: {
        'Cache-Control': 'no-store'
      }
    })
  },

  syncRoles(userId: number, roles: Array<number>) {
    return visit<MessageResponse>({
      method: 'PUT',
      url: 'users/' + userId + '/sync_roles',
      data: { roles }
    })
  },

  syncPolicies(userId: number, policies: Array<number>) {
    return visit<MessageResponse>({
      method: 'PUT',
      url: 'users/' + userId + '/sync_policies',
      data: { policies }
    })
  }
}
